import { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { MainWrapper } from '../component/MainWrapper'
import { TopBar } from '../component/TopBar'
import { CandidateLeftSidebar } from './component/Candidate-details/CandidateLeftSidebar'
import { CondidateRightSidebar } from './component/Candidate-details/CondidateRightSidebar'
import { ChatPopup } from './component/Candidate-details/ChatPopup'
import { FormattedMessage } from 'react-intl'
import { getApplication } from 'sr/utils/api/cleaner/getApplication'
import CleanerType from 'app/pages/cleaner/component/type/CleanerType'
import ContentWithSpinner from 'sr/layout/common/ContentWithSpiner'
import { getUserDetails } from 'sr/helpers/functions/getUserDetails'
import { useNavigate } from 'react-router-dom'
import { getFile } from 'sr/utils/api/getFile'
import { pdfjs } from 'react-pdf'
import { ApplicationStatus } from 'sr/i18n/messages/setting'
import getLabelByValue from 'sr/helpers/functions/getLabelByValue'
import { DownloadResume } from 'sr/helpers/functions/ApiFunction.tsx/DownloadResume'
import { CandidateProfile } from './component/Candidate-details/CandidateProfile'
import fetchEmployment from 'sr/helpers/apiFunctions/common/fetchEmployment'
import fetchMedical from 'sr/helpers/apiFunctions/common/fetchMedical'
import fetchTraining from 'sr/helpers/apiFunctions/common/fetchTraining'
import { LoaderFullScreen } from 'sr/layout/common/LoaderFullScreen'
import { getReference } from 'sr/utils/api/cleaner/getReference'
import { getUserFullProfile } from 'sr/utils/api/user/user'
export const CandidateView = () => {
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

  const params = useParams()
  const navigate = useNavigate()
  const [id, setId] = useState<string>()
  const [application, setApplicant] = useState(null)
  const [allApplicant, setAllApplicant] = useState(null)
  const [candidate, setCandidate] = useState(null)
  const [cleaner, setCleaner] = useState<CleanerType>(null)
  const [training, setTraining] = useState(null)
  const [medical, setMedical] = useState(null)
  const [employment, setEmployment] = useState(null)
  const [candidates, setCandidates] = useState(null)
  const [loader, setLoader] = useState(false)
  const [companyId, setCompanyId] = useState()
  const [totalCandidate, setTotalCandidate] = useState(null)
  const [currentPage, setCurrentPage] = useState(0)
  const [resume, setResume] = useState(null)
  const [resumeKey, setResumeKey] = useState(null)
  const [backStatus, setBackStatus] = useState()
  const [resumeLoader, setResumeLoader] = useState(false)
  const [reference, setRefrence] = useState()
  const [resumeExt, setResumeExt] = useState('')
  const [isAllowedPreOnBordingSubmission, setIsAllowedPreOnBordingSubmission] = useState(false)
  const [requiredPreOnBordingChecklist, setRequiredPreOnBordingChecklist] = useState<{ name: string; isRequired?: boolean }[]>([])
  useEffect(() => {
    const fetchUserProfile = async () => {
      const result = await getUserFullProfile()
      setIsAllowedPreOnBordingSubmission(
        result?.data?.user_type_detail?.isAllowedPreOnBordingSubmission === true
      )
      setRequiredPreOnBordingChecklist(
        result?.data?.user_type_detail?.requiredPreOnBordingChecklist || []
      )
    }

    fetchUserProfile()
  }, [])
  useEffect(()=> {
    const userData =  getUserDetails()
    setCompanyId(userData?.user_id)
  }, [])


  useEffect(()=> {
  
    const {id} = params
    setId(id)
  }, [params])
  useEffect(()=> {
    const fetchAllCandidate = async (job_id)=> {
      const queryParams = new URLSearchParams();  
      queryParams.append('job_id', job_id?.toString());
 const result = await getApplication(queryParams)
 if(result?.success===true) {
  const allid=[]
  for(let i =0; i<result?.data?.length; i++) {
      allid.push(result?.data[i].id)
  }
  setAllApplicant(allid)
  setCandidates(result?.data)
  setTotalCandidate(result?.pagination?.statusCounts[candidate?.status])
 }
    }
    if(candidate?.job_id?.id) {
      fetchAllCandidate(candidate?.job_id?.id)
    }
},[candidate?.job_id?.id ])
 const fetchReference = async (cleanerId) => { 
  try {
    const referenceData = await getReference(cleanerId, undefined, true);
    
    if (referenceData?.success) {
      setRefrence(referenceData.data);
      
    }
    else {

    }
  }
  catch(e:any){

  }
  };
  
const fetchCandidate = async (id) => {
  setLoader(true)
  try {
const queryParams = new URLSearchParams();  
       queryParams.append('id', id.toString());
  const result = await getApplication(queryParams)
  if(result?.success===true) {
    setCandidate(result?.data)
    setBackStatus(result?.data?.status)
    fetchTraining({cleanerId:result?.data?.cleaner_id?._id, setData:setTraining})
      }
      fetchMedical({cleanerId:result?.data?.cleaner_id?._id, setData:setMedical})
      fetchEmployment({cleanerId:result?.data?.cleaner_id?._id, setData:setEmployment, setLoader:setLoader})
 fetchReference(result?.data?.cleaner_id?._id)
      setResume('')
      setResumeKey('')
      if(result?.data?.job_resume){
        setResumeKey(result?.data?.job_resume)
const getfile = await getFile(result?.data?.job_resume)

if (getfile) {
const urlWithoutParams = getfile.split('?')[0];
const fileName = urlWithoutParams?.split('/').pop(); 
const getExtension = fileName?.split('.').pop()?.toLowerCase();
  setResumeExt(getExtension)
if(getExtension==='pdf'){
  setResume(getfile);
}
if(getExtension==='docx'){
  const encodedUrl = encodeURIComponent(getfile);
    setResume(`https://view.officeapps.live.com/op/view.aspx?src=${encodedUrl}`);
}
}
  }
  }
  catch(e:any) {
  }
}
useEffect(()=> {
    if(id) {
    fetchCandidate(id)
    }
  }, [id])

  useEffect(()=> {
if(id && allApplicant) {
  const index =  allApplicant?.indexOf(id)
        setCurrentPage(index)
}
  },[allApplicant, id])

const HandlePageChange = async (index)=> {
    if(index>allApplicant?.length-1 || index < 0){
      return
    }
    const id = allApplicant[index]
    navigate(`/candidate-details/${id}`)
}

  const address_line_1 = candidate?.job_id?.job_advanced_id?.reporting_address?.address_line_1;
  const address_line_2 = candidate?.job_id?.job_advanced_id?.reporting_address?.address_line_2;
  const reportingCity = candidate?.job_id?.job_advanced_id?.reporting_address?.city;
 

  return (
    <MainWrapper >
      {resumeLoader && <LoaderFullScreen />}
    <div className='py-3'>
        <TopBar title = {<FormattedMessage
          id='RECRUITER.CANDIDATES.CANDIDATES.TITLE'
          defaultMessage='Candidates'
        />} className='px-10'></TopBar>
    <div className='pl-10'>
    <div className='flex items-center justify-between'>
<div className='flex items-center space-x-4'>
<Link to={`/candidates/${backStatus}`}>
<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="text-[#0078ae] w-5 h-5 cursor-pointer">
  <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
</svg>
</Link>
<div>
    <h2 className=''>{candidate?.job_id?.job_title}{address_line_1 || address_line_2 || reportingCity ? ` - ` : ''}{address_line_1} {address_line_2} {reportingCity}</h2>
    <Link to={`/candidates/${backStatus}`}>
      <p className='text-base  text-[#0078ae] font-bold'> <FormattedMessage id="RECRUITER.CANDIDATES.BACKBUTTON" defaultMessage="Back to" /> {getLabelByValue(backStatus, ApplicationStatus)}  </p>
      </Link>
</div>

</div>
<nav className=' flex flex-wrap justify-center items-center lg:space-x-8'>
{candidate?.job_id?.id && (
  <Link
    to={`/postedjob-details/${candidate?.job_id?.id}`}
    className="flex items-center justify-center px-4 h-8 leading-tight text-[#0078ae] font-bold bg-white border border-gray-300 rounded-[20px] hover:bg-gray-100 hover:text-[#0078ae]"
  >
    <FormattedMessage
      id="RECRUITER.CANDIDATE.VIEW.JOB.POSTING.BUTTON"
      defaultMessage="View job posting"
    />
  </Link>
)}
    <p className='font-bold text-sm text-[#717b9e]'><FormattedMessage id="RECRUITER.CANDIDATES.PAGEINATION.TITLE" defaultMessage="Candidate {activeNumber} of {totalNumber}" values={{activeNumber:currentPage+1, totalNumber:allApplicant?.length}} /></p>
  <ul className="items-center inline-flex lg:space-x-2 text-base h-10 justify-between w-full lg:w-fit">
    <li onClick={()=> HandlePageChange(currentPage-1)}>
      <Link to="#" className="flex items-center justify-center px-4 h-8 ml-0 leading-tight text-[#0078ae] font-bold bg-white border border-gray-300 rounded-[20px] hover:bg-gray-100 hover:text-[#0078ae] "><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-4 h-4">
  <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
</svg> <FormattedMessage id="PAGEINATION.PREVIOUS.BUTTON" defaultMessage="Previous" />  </Link>
    </li>

    <li onClick={()=> HandlePageChange(currentPage+1)}>
      <Link to="#" className="flex items-center justify-center px-4 h-8 leading-tight text-[#0078ae] font-bold bg-white border border-gray-300 rounded-[20px] hover:bg-gray-100 hover:text-[#0078ae]"><FormattedMessage id="PAGEINATION.NEXT.BUTTON" defaultMessage="Next" /> <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-4 h-4">
  <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
</svg>
</Link>
    </li>
  </ul>
</nav>
    </div>
    <div className='grid grid-cols-12 gap-7 mt-10'>
   <div className='col-span-3 bg-white rounded-[18px] h-fit'>
    <CandidateLeftSidebar candidates = {candidates} total={totalCandidate} currentPage = {currentPage} allApplicant = {allApplicant}/>
  <div>

 <div>
</div>
</div>
   </div>
   {<ContentWithSpinner loader={loader}>
   <div className='col-span-9'>
    <div className='flex'>
    <div className='bg-white rounded-lg p-5 w-[125rem] shadow-boxshadowpage'>
<CandidateProfile reference={reference} employment={employment} training={training} medical={medical} candidate={candidate}/>
<div className='border-b border-neutral-200 py-5 flex justify-between items-center'>
<span className='text-base '><FormattedMessage id="RECRUITER.CANDIDATE.CV.TITLE" defaultMessage="CV" /> </span>
{resumeKey ?
<div onClick={()=> DownloadResume({resumeName:'bbnett.pdf', resumeKey:resumeKey, setLoader:setResumeLoader})} className='text-[#0078ae] font-bold  cursor-pointer border border-neutral-200 px-3 py-1.5 text-base rounded-lg'>
<FormattedMessage id="RECRUITER.CANDIDATE.CV.BUTTON" defaultMessage="Download PDF" /> 
</div>
:
<div className=' text-lg'>Not Available</div>
}
</div>
{resume &&
<div className={`w-full ${resumeExt==='docx' ? 'h-[500px] overflow-scroll': '' }`}>
  <iframe className="w-full h-[1000px] border-none" src={resume}></iframe>
</div>

}
   </div>
   <div className='w-full'>
<CondidateRightSidebar status = {candidate?.status} candidate={candidate} setBackStatus={setBackStatus} resumeKey={resumeKey} isAllowedPreOnBordingSubmission={isAllowedPreOnBordingSubmission} requiredPreOnBordingChecklist={requiredPreOnBordingChecklist}/>
   </div>
   
   </div>
   
   </div>
   </ContentWithSpinner>
   }
   </div>
    </div>
   <ChatPopup candidate={candidate}/>
    </div>
    </MainWrapper>
  )
}
